import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { createStackNavigator } from '@react-navigation/stack';
import i18n from 'i18n-js';

import Homescreen from '../screens/Homescreen';
import Blank from '../screens/Blank';
import Header from "../components/basic/Header";
import MediaManager from '../components/media/MediaManager';

import Workflows from '../screens/workflows/Workflows';
import DeletedWorkflows from '../screens/workflows/DeletedWorkflows';
import ShowWorkflow from '../screens/workflows/ShowWorkflow';
import WorkflowEdit, { updateStep } from '../screens/workflows/WorkflowEdit';
import ShowStep, { updateItemState } from '../screens/workflows/ShowStep';
import DecisionEdit, { updateExtraStep } from '../screens/workflows/DecisionEdit';
import StepEdit, { updateItem, updateDecison } from '../screens/workflows/StepEdit';
import ShowItem from '../screens/workflows/ShowItem';
import ItemEdit from '../screens/workflows/ItemEdit';

import ModalFilter from "../screens/modals/ModalFilter";
import ModalReport from "../screens/modals/ModalReport";
import ModalSupport from "../screens/modals/ModalSupport";
import ModalMessage from "../screens/modals/ModalMessage";
import ModalGame from '../screens/modals/ModalGame';
import ModalAdmin from '../screens/modals/ModalAdmin';
import VideoTest from '../screens/VideoTest'
import Planner from "../screens/planning/Planner";
import Chat from '../screens/Chat';
import SelectWorkflow from "../screens/planning/SelectWorkflow";
import PublicWorkflows from '../screens/sharing/PublicWorkflows';
import ScheduleWorkflow from "../screens/planning/ScheduleWorkflow";
import Tutorial from "../screens/Tutorial";
import ShareWorkflow from "../screens/sharing/ShareWorkflow";
import StepTypeInformation from "../screens/workflows/StepTypeInformation";

import ContactManagement from "../screens/sharing/ContactManagement";
import Contact, { updateContactChilds } from "../screens/sharing/Contact";
import Channel, { updateChilds } from "../screens/sharing/Channel";
import SharedWorkflows from "../screens/sharing/SharedWorkflows";
import Alternatives from "../screens/Alternatives";
import ModalAddContactEmail from "../screens/modals/ModalAddContactEmail";
import ScanQRCode from "../screens/sharing/ScanQRCode";
import ModalRequestSent from "../screens/modals/ModalRequestSent";
import Contacts from "../screens/sharing/Contacts";
import ContactsSelect from '../screens/sharing/ContactsSelect';
import Channels from "../screens/sharing/Channels";
import Publisher from '../screens/sharing/Publisher';
import perfTrace from '../hooks/navigate';
import ShareQRCode from '../screens/sharing/ShareQRCode';
import PrintQRCode from '../screens/sharing/PrintQRCode';
import PrintSelect from '../screens/sharing/PrintSelect';
import AuthenticateSession from '../screens/AuthenticateSession';
import Playground from './Playground';
import { Easing } from 'react-native-reanimated';
import Finished from '../screens/workflows/Finished';
import TaskSettings from '../screens/workflows/TaskSettings';
import ModalFcm from "../screens/modals/ModalFcm";
import { storePerf, taskTimer } from "@/stores/mainSlice";
import PlannerRequests from "@/screens/planning/PlannerRequests";
import RequestPlanning from "@/screens/planning/RequestPlanning";
import ShowWorkflow2 from "@/screens/workflows/ShowWorkflow2";

const mainStack = createStackNavigator()

export default function MainStack({ isSimulator = false }) {

    const timerTasks = useSelector((state) => state.tasks.high)
    const workflows = useSelector((state) => state.workflows)
    const settings = useSelector((state) => state.settings)
    const dispatch = useDispatch()

    useEffect(() => {
        let timerInterval = null
        if (timerTasks.length > 0) {
            if (!timerInterval) {
                console.log("BEG Timer")
                // start the regular check for timer updates
                timerInterval = setInterval(() => {
                    timerTasks.forEach(taskid => {
                        let task = workflows[taskid]
                        task.steps.forEach((step, s) => {
                            if (step.timer && step.timerBeg) {
                                let time
                                if (step.timerPause) {
                                    time = step.timer - Math.round((step.timerPause - step.timerBeg) / 1000)
                                } else {
                                    time = step.timer - Math.round((Date.now() - step.timerBeg) / 1000)
                                }
                                if (time <= 0) {
                                    console.log("DONE Timer step " + s)
                                    dispatch(taskTimer({
                                        taskid: taskid,
                                        stepIdx: s,
                                        start: false,
                                        done: true,
                                        isSimulator
                                    }))
                                }
                            }
                        })
                    })
                }, 1000)
            }
        } else {
            if (timerInterval) {
                console.log("END Timer")
                clearInterval(timerInterval)
                timerInterval = null
            }
        }
        return function cleanup() {
            if (timerInterval) {
                console.log("END Timer")
                clearInterval(timerInterval)
                timerInterval = null
            }
        }
    }, [timerTasks])

    // InteractionManager.runAfterInteractions(() => {
    //   console.log('Start Sync')
    //   // ...long-running synchronous task...
    // });

    const timing = {
        animation: 'timing',
        config: {
            duration: 0.5,
            easing: Easing.out(Easing.poly(4))
        }
    }

    const spring = {
        animation: 'spring',
        config: {
            stiffness: 1000,
            damping: 500,
            mass: 3,
            overshootClamping: true,
            restDisplacementThreshold: 0.01,
            restSpeedThreshold: 0.01,
        }
    }

    const slideDown = ({ current, layouts }) => {
        // console.log("vertival")
        return {
            cardStyle: {
                transform: [
                    {
                        translateY: current.progress.interpolate({
                            inputRange: [0, 1],
                            outputRange: [layouts.screen.height, 0],
                        }),
                    },
                ],
            },
        }
    }

    const verticalAnimation = {
        headerShown: true,
        header: (props) => <Header {...props} />,
        hidePhone: isSimulator,
        presentation: 'modal',
        gestureEnabled: true,
        gestureDirection: 'vertical',
        // transitionSpec: { open: spring, close: spring },
        cardStyleInterpolator: slideDown
    }

    // TODO: ShareWorkflow without Back gesture (fixed in ​react-native-gesture-handler 2.6.0)
    return (
        <mainStack.Navigator initialRouteName={settings.tutorialShown ? 'Home' : 'Tutorial'} screenOptions={verticalAnimation} screenListeners={({ navigation }) => ({
            focus: (e) => {
                if (settings.perf) {
                    const perf = perfTrace(navigation, 'OPN')
                    dispatch(storePerf({ data: perf }))
                }
            },
            transitionEnd: (e) => {
                if (settings.perf) {
                    const perf = perfTrace(navigation, e.data.closing ? 'CLS' : 'RDY')
                    dispatch(storePerf({ data: perf }))
                }
            },
            // blur: (e) => {
            //     let screens = navigation.getState().routes.map(route => route.name)
            //     screens.pop()
            //     console.log('SCREEN END', screens.pop(), Date.now());
            // },
            // state: (e) => {
            //     console.log('SCREEN NAV', e.data.state.routes.map(route => route.name).pop(), Date.now());
            // },
        })}>
            <mainStack.Group>
                <mainStack.Screen name='Tutorial' component={Tutorial} options={{ headerShown: false }} />
                <mainStack.Screen name='Home' component={Homescreen} options={{ homeScreen: true }} />
                <mainStack.Screen name='Workflows' component={Workflows} options={{ title: i18n.t('workflowsScreen.title'), info: i18n.t('workflowsScreen.info0'), showMoreOptionsMenu: true, gestureEnabled: true }} />
                <mainStack.Screen name='DeletedWorkflows' component={DeletedWorkflows} options={{ title: i18n.t('deletedWorkflows.title') }} />
                <mainStack.Screen name='Planner' component={Planner} options={{ title: i18n.t('plannerScreen.title'), info: i18n.t('plannerScreen.info') }} />
                <mainStack.Screen name='PlannerRequests' component={PlannerRequests} options={{ title: i18n.t('plannerRequest.title') }} />
                <mainStack.Screen name='RequestPlanning' component={RequestPlanning} options={{ title: i18n.t('plannerRequest.title') }} />
                <mainStack.Screen name='Blank' component={Blank} />
                <mainStack.Screen name='ShowWorkflow' component={ShowWorkflow} options={{ title: i18n.t('showWorkflowScreen.title'), showReport: true }} />
                <mainStack.Screen name='ShowWorkflow2' component={ShowWorkflow2} options={{ title: i18n.t('showWorkflowScreen.title'), showReport: !isSimulator }} />
                <mainStack.Screen name='ShareWorkflow' component={ShareWorkflow} options={{ title: i18n.t('moreOptionsMenu.share') }} />
                <mainStack.Screen name='WorkflowEdit' component={WorkflowEdit} options={{ headerShown: true }} />
                <mainStack.Screen name='ShowStep' component={ShowStep} options={{ headerShown: true }} />
                <mainStack.Screen name='Finished' component={Finished} options={{ headerShown: true, title: i18n.t('finishedScreen.title') }} />
                <mainStack.Screen name='TaskSettings' component={TaskSettings} options={{ headerShown: true, title: i18n.t('taskSettings.title') }} />
                <mainStack.Screen name='StepTypeInformation' component={StepTypeInformation} options={{ title: i18n.t('stepTypeInformation.title') }} />
                <mainStack.Screen name='StepEdit' getId={({ params }) => params.name}>
                    {(props) => <StepEdit  {...props} updateStep={updateStep} updateExtraStep={updateExtraStep} />}
                </mainStack.Screen>
                <mainStack.Screen name='DecisionEdit' >
                    {(props) => <DecisionEdit  {...props} updateDecison={updateDecison} />}
                </mainStack.Screen>
                <mainStack.Screen name='ItemEdit' >
                    {(props) => <ItemEdit  {...props} updateItem={updateItem} />}
                </mainStack.Screen>
                <mainStack.Screen name='ShowItem' options={{ title: i18n.t('showItemScreen.title') }} >
                    {(props) => <ShowItem  {...props} updateItemState={updateItemState} />}
                </mainStack.Screen>
                <mainStack.Screen name='MediaManager' component={MediaManager} />
                <mainStack.Screen name='VideoTest' component={VideoTest} options={{ title: 'Video' }} />
                <mainStack.Screen name='SelectWorkflow' component={SelectWorkflow} options={{ title: i18n.t('scheduleWorkflow.info'), info: i18n.t('scheduleWorkflow.choose') }} />
                <mainStack.Screen name='ScheduleWorkflow' component={ScheduleWorkflow} options={{ title: i18n.t('scheduleWorkflow.info'), info: i18n.t('scheduleWorkflow.details') }} />
                <mainStack.Screen name='PublicWorkflows' component={PublicWorkflows} options={{ title: i18n.t('shareQRCode.ownTasks'), info: i18n.t('shareQRCode.info'), showMoreOptionsMenu: true, public: true }} />
                <mainStack.Screen name='Publisher' component={Publisher} options={{ title: i18n.t('shareQRCode.publicShare') }} />
                <mainStack.Screen name='ShareQRCode' component={ShareQRCode} options={{ title: i18n.t('shareQRCode.title'), info: i18n.t('shareQRCode.info') }} />
                <mainStack.Screen name='PrintQRCode' component={PrintQRCode} options={{ headerShown: false, title: i18n.t('printQRCode.title'), info: i18n.t('printQRCode.info') }} />
                <mainStack.Screen name='PrintSelect' component={PrintSelect} options={{ title: i18n.t('printQRCode.title'), info: i18n.t('printQRCode.info') }} />
                <mainStack.Screen name='AuthenticateSession' component={AuthenticateSession} options={{ title: i18n.t('shareQRCode.info') }} />
                <mainStack.Screen name='Chat' component={Chat} options={{ title: i18n.t('chatScreen.title'), info: i18n.t('chatScreen.info') }} />
            </mainStack.Group>
            <mainStack.Group>
                <mainStack.Screen name='ContactManagement' component={ContactManagement} options={{ title: i18n.t('contactManagement.title'), headerShown: false }} />
                <mainStack.Screen name='Contacts' component={Contacts} options={{ title: i18n.t('contact.contacts') }} />
                <mainStack.Screen name='Contact' component={Contact} options={{ title: i18n.t('contact.title') }} />
                <mainStack.Screen name='ContactsSelect' options={{ title: i18n.t('contact.contacts') }}>
                    {(props) => <ContactsSelect  {...props} updateChilds={updateChilds} />}
                </mainStack.Screen>
                <mainStack.Screen name='SharedWorkflows' options={{ title: i18n.t('contact.workflows') }}>
                    {(props) => <SharedWorkflows  {...props} updateChilds={updateChilds} updateContactChilds={updateContactChilds} />}
                </mainStack.Screen>
                <mainStack.Screen name='Channels' options={{ title: i18n.t('channel.channels') }}>
                    {(props) => <Channels  {...props} updateContactChilds={updateContactChilds} />}
                </mainStack.Screen>
                <mainStack.Screen name='Channel' component={Channel} options={{ title: i18n.t('channel.title') }} />
                <mainStack.Screen name='Alternatives' component={Alternatives} options={{ title: i18n.t('addContact.title') }} />
                <mainStack.Screen name='ScanQRCode' component={ScanQRCode} options={{ title: i18n.t('addContact.scanCode') }} />
                <mainStack.Screen name='Playground' component={Playground} options={{ title: i18n.t('playground.title') }} />
            </mainStack.Group>
            <mainStack.Group screenOptions={{ headerShown: false, presentation: 'transparentModal' }}>
                <mainStack.Screen name='ModalAddContactEmail' component={ModalAddContactEmail} />
                <mainStack.Screen name='ModalRequestSent' component={ModalRequestSent} />
            </mainStack.Group>
            <mainStack.Group screenOptions={{ headerShown: false, presentation: 'transparentModal' }}>
                <mainStack.Screen name='ModalMessage' component={ModalMessage} options={{ title: i18n.t('message.info') }} />
                <mainStack.Screen name='ModalFilter' component={ModalFilter} />
                <mainStack.Screen name='ModalReport' component={ModalReport} />
                <mainStack.Screen name='ModalSupport' component={ModalSupport} />
                <mainStack.Screen name='ModalGame' component={ModalGame} />
                <mainStack.Screen name='ModalAdmin' component={ModalAdmin} />
                <mainStack.Screen name='ModalFcm' component={ModalFcm}/>
            </mainStack.Group>
        </mainStack.Navigator>
    )
}
